export default "__VITE_ASSET__DQZsiOv9__"